module.exports = __webpack_public_path__ + "static/media/CaptureWGHT2.1a4b34a0.PNG";